import { render, staticRenderFns } from "./Chatflows.vue?vue&type=template&id=6ead1222&scoped=true"
import script from "./Chatflows.vue?vue&type=script&lang=js"
export * from "./Chatflows.vue?vue&type=script&lang=js"
import style0 from "./Chatflows.vue?vue&type=style&index=0&id=6ead1222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ead1222",
  null
  
)

export default component.exports